import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './features/auth/context/AuthContext';
import { AppRoutes } from './Routes/AppRoutes';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import useBackendStatus from './hooks/useBackendStatus';
import SplashScreen from './pages/SplashScreen';
import MaintenancePage from './pages/Maintenance';


const queryClient = new QueryClient();

const App: React.FC = () => {
  const { isOnline, isChecking, manualRetry, retryCount, lastChecked } = useBackendStatus();
  const [splashDelayDone, setSplashDelayDone] = useState(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(() => {
    return localStorage.getItem('hasSeenSplash') === 'true';
  });


  useEffect(() => {
    const timer = setTimeout(() => setSplashDelayDone(true), 5000); // full 5 sec
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (splashDelayDone && !hasLoadedOnce) {
      localStorage.setItem('hasSeenSplash', 'true');
      setHasLoadedOnce(true);
    }
  }, [splashDelayDone, hasLoadedOnce]);


  const shouldShowSplash = !hasLoadedOnce || !splashDelayDone;

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          {shouldShowSplash ? (
            <SplashScreen />
          ) : !isOnline ? (
            <MaintenancePage
              onRetry={manualRetry}
              isChecking={isChecking}
              retryCount={retryCount}
              lastChecked={lastChecked}
            />
          ) : (
            <AppRoutes />
          )}
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
